import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppProvider from "./contextApi/AppProvider";
import ReduxProvider from "./redux/provider";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
      <ReduxProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </ReduxProvider>
  </React.StrictMode>
);
